/* eslint-disable */
import { WorkflowStepFunction, WorkflowEvent } from '../index';

declare var Object: any;
export interface WorkflowStepFunctionPublishedEventInterface {
  id?: any;
  workflowEventId?: string;
  workflowStepFunctionId?: string;
  workflowEvent?: WorkflowEvent;
  workflowStepFunction?: WorkflowStepFunction;
}

export class WorkflowStepFunctionPublishedEvent
  implements WorkflowStepFunctionPublishedEventInterface {
  'id'?: any;
  'workflowEventId'?: string;
  'workflowStepFunctionId'?: string;
  workflowEvent?: WorkflowEvent;
  workflowStepFunction?: WorkflowStepFunction;
  constructor(data?: WorkflowStepFunctionPublishedEventInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `WorkflowStepFunction`.
   */
  public static getModelName() {
    return 'WorkflowStepFunctionPublishedEvent';
  }
  /**
   * @method factory
   * @author Jonathan Casarrubias
   * @license MIT
   * This method creates an instance of WorkflowStepFunction for dynamic purposes.
   **/
  public static factory(
    data: WorkflowStepFunctionPublishedEventInterface
  ): WorkflowStepFunctionPublishedEvent {
    return new WorkflowStepFunctionPublishedEvent(data);
  }
  /**
   * @method getModelDefinition
   * @author Julien Ledun
   * @license MIT
   * This method returns an object that represents some of the model
   * definitions.
   **/
  public static getModelDefinition() {
    return {
      name: 'WorkflowStepFunctionPublishedEvent',
      plural: 'WorkflowStepFunctionPublishedEvents',
      path: 'workflow-step-function-published-event',
      idName: 'id',
      properties: {
        workflowEventId: {
          name: 'workflowEventId',
          type: 'string',
        },
        workflowStepFunctionId: {
          name: 'workflowStepFunctionId',
          type: 'string',
        },
        id: {
          name: 'id',
          type: 'any',
        },
      },
      relations: {
        workflowEvent: {
          name: 'workflowEvent',
          type: 'WorkflowEvent',
          model: 'WorkflowEvent',
          relationType: 'belongsTo',
          keyFrom: 'workflowEventId',
          keyTo: 'id',
        },
        WorkflowStepFunction: {
          name: 'workflowStepFunction',
          type: 'WorkflowStepFunction',
          model: 'WorkflowStepFunction',
          relationType: 'belongsTo',
          keyFrom: 'workflowStepFunctionId',
          keyTo: 'id',
        },
      },
    };
  }
}
